<template>
  <div :class="$style.nav">
    <div
      v-for="(year, index) in years"
      :key="index"
      :class="[$style.tab, active === String(year) && $style.tab_active]"
    >
      <button :disabled="active === String(year)" @click="$emit('click', year)">
        {{ index === 0 ? '现在' : year }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: { type: String, default: '' },
    years: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>

<style lang="less" module>
.nav {
  display: flex;
  justify-content: center;
}

.tab {
  @tab-size: 0.54rem;
  @tab-font-size: 0.16rem;
  @tab-padding-right: 1.26rem;
  @line-width: 1.8rem;
  @line-height: 0.07rem;

  .tab-size(@r: 1) {
    button {
      .size(@tab-size * @r);
      font-size: @tab-font-size * @r;
    }

    &:not(:last-child) {
      &::before {
        .size(@line-width * @r, @line-height * @r);
      }
    }
  }

  .tab-size();

  @media screen and (max-width: @tablet-width) {
    .tab-size(1.5);
  }

  @media screen and (max-width: @mini-width) {
    .tab-size(2);
  }

  @media screen and (max-width: @mobile-width) {
    .tab-size(2.8);
  }

  position: relative;
  user-select: none;

  button {
    z-index: 1;
    position: relative;
    border-radius: 100%;
    background-color: #e2c692;
    font-weight: 700;
  }

  &:not(:last-child) {
    padding-right: @tab-padding-right;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      background: url('./images/history-line.png') no-repeat 0 100%;
      background-size: 100% 200%;

      @media screen and (max-width: @mobile-width) {
        content: none;
      }
    }
  }

  &:first-child::before {
    background-position: 0 0;
  }

  &_active {
    button {
      background-color: @primary;
      color: #fff;
      box-shadow: 0 0 0.1rem 0.05rem fade(#ff3d4c, 23%);
    }
  }
}
</style>
